var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16345 0 0 7.16344 0 16C0 24.8366 7.16345 32 16 32Z",
    fill: "url(#paint0_linear_1078_60725)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8453 27.7602C23.8945 25.3358 20.1173 23.8804 16.0002 23.8804C11.8827 23.8804 8.10524 25.3361 5.1543 27.7609C5.1543 27.7609 9.02778 32.0002 16.0002 32.0002C22.9727 32.0002 26.8453 27.7602 26.8453 27.7602Z",
    fill: "#07B723"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 19.3015C19.0352 19.3015 21.4958 16.8409 21.4958 13.8055C21.4958 10.7702 19.0352 8.30957 15.9999 8.30957C12.9645 8.30957 10.5039 10.7702 10.5039 13.8055C10.5039 16.8409 12.9645 19.3015 15.9999 19.3015Z",
    stroke: "#07B723",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1078_60725",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0FFDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0DFCF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAvatar);
export default __webpack_public_path__ + "static/media/person_avatar.cc4c3674be6d25090d1f6370cc470662.svg";
export { ForwardRef as ReactComponent };